import React from 'react';

import { Link } from '~/lib/react-router-dom';

import ArticleIcon from '@mui/icons-material/Article';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DescriptionIcon from '@mui/icons-material/Description';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaymentsIcon from '@mui/icons-material/Payments';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

const WORKFLOW_ITEMS = [
  { label: 'Hotel Proposal Pricing Tool', icon: PaymentsIcon, pathSuffix: '/hotel-proposal-pricing-tool' },
  { label: 'Assets', icon: FolderOpenIcon, pathSuffix: '/assets' },
  { label: 'Deal Information', icon: DescriptionIcon, pathSuffix: '/deal-information' },
  { label: 'CM Checklist', icon: ChecklistIcon, pathSuffix: '/cm-checklist' },
  { label: 'Rates and Inventory', icon: EventNoteIcon, pathSuffix: '/rates-and-inventory' },
  { label: 'Content', icon: ArticleIcon, pathSuffix: '/content' },
];

interface Props {
  activeItem?: string;
  hotelCode?: string;
  hotelName: string;
  location: string;
  offerId: string;
}

export default function OfferBuilderSidebar({
  activeItem = 'Content',
  hotelCode,
  hotelName,
  location,
  offerId,
}: Props) {
  const basePath = `/offers/${offerId}/offer-builder`;

  return (
    <Paper
      square
      variant="outlined"
      sx={{
        display: { xs: 'none', lg: 'block' },
        minHeight: '100vh',
        borderTop: 0,
        borderBottom: 0,
        borderLeft: 0,
        px: 3,
        py: 2.5,
      }}
    >
      <Box sx={{ pb: 2, mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle1" fontWeight={600}>
          {hotelName}
        </Typography>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ color: 'text.secondary', mt: 1 }}>
          <LocationOnIcon fontSize="small" />
          <Typography variant="body2">{location}</Typography>
        </Stack>
        {hotelCode && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, overflowWrap: 'anywhere' }}>
            {hotelCode}
          </Typography>
        )}
      </Box>

      <Typography variant="overline" color="text.secondary">
        Hotel proposal
      </Typography>
      <Stack component="nav" spacing={0.5} sx={{ mt: 1 }}>
        {WORKFLOW_ITEMS.map(({ label, icon: Icon, pathSuffix }) => (
          <Button
            key={label}
            component={Link}
            to={`${basePath}${pathSuffix}`}
            startIcon={<Icon />}
            variant={activeItem === label ? 'contained' : 'text'}
            color="primary"
            fullWidth
            sx={{ justifyContent: 'flex-start', textTransform: 'none', whiteSpace: 'nowrap' }}
          >
            {label}
          </Button>
        ))}
      </Stack>
    </Paper>
  );
}
